import { Chip } from "@mui/material";

const RubricPointsChip = ({ points, title, colors = {} }) => {
  return (
    <Chip
      size="small"
      label={title || `Total points: ${points}`}
      color="primary"
      variant="outlined"
      sx={{
        borderColor: "#B2DDFF",
        bgcolor: "#EFF8FF",
        color: "#175CD3",
        ...colors,
      }}
    />
  );
};
export default RubricPointsChip;
